<template>
  <div class="r-mark">
    <swiper class="swiper" :options="swiperOption" ref="mark">
      <swiper-slide class="stop-swiping" v-for="(list,index) in (data)" :key="index">
        <v-card :list="list"></v-card>
      </swiper-slide>
    </swiper>
    <div class="d-none d-md-block" style="left:0">
      <div class="swiper-button" v-if="data.length>=pre_view">
        <div class="swiper-button-prev swiper-button-black" slot="button-prev"></div>
      </div>
      <div class="swiper-button" style="right:0" v-if="data.length>=pre_view">
        <div class="swiper-button-next swiper-button-black" slot="button-next"></div>
      </div>
    </div>
  </div>
</template>

<script>
import vCard from "./card";
export default {
  props:{
    data:{
      type:Array,
      default:[]
    },
    spacebetween:{
      type:Number,
      default:30
    },
    loop:{
      type:Boolean,
      default:false
    },
    pre_view:{
      type:Number,
      default:6
    }
  },
  data() {
    return {
      swiperOption: null
    };
  },
  beforeMount() {
    const options = {
      loop: this.loop,
      spaceBetween: this.spacebetween,
      slidesPerView: this.data.length > this.pre_view ? this.pre_view : this.data.length,
      noSwiping: this.data.length > this.pre_view ? false : true,
      noSwipingClass: "stop-swiping",
      width: undefined, //取消移动端width，恢复自适应
      //Swiper4.x版本为小于
      breakpoints: {
        768: {
          //当屏幕宽度小于等于768
          noSwiping: this.data.length > 1 ? false : true,
          slidesPerView: 1,
          width: 305,
          spaceBetween: 12
        }
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    };

    this.swiperOption = options;
  },
  computed: {
    //获取swiper实例
    swiper() {
      return this.$refs.mark.swiper;
    }
  },
  components: {
    vCard
  }
};
</script>
<style lang="scss" >
.r-mark {
  position: relative;
  .swiper-button-prev,
  .swiper-button-next {
    width: 40px;
    height: 100%;
    margin-top: 0;
    top: 0;
    background-size: 25% 25%;
  }
  .swiper-button {
    background: #ffffff;
    opacity: 0.5;
    height: 100%;
    position: absolute;
    width: 40px;
    top: 0;
    z-index: 1;
  }
  .swiper-button-prev {
    left: 0;
  }
  .swiper-button-next {
    right: 0;
  }
}

@media (max-width: 767px) {
  .r-mark {
    .swiper-button-prev,
    .swiper-button-next {
      height: 22px;
    }
    .swiper-button-prev {
      left: 0;
    }
    .swiper-button-next {
      right: 0;
    }
  }
}
@media (min-width: 768px) {
  .p-md-35 {
    padding: 0 35px;
  }
}
</style>